import { SPECS_TO_DISPLAY, VISIBLE_SPECS } from './constants'

export const filterSpecs = (specs = []) =>
  specs
    .filter(({ specName = '' } = {}) => VISIBLE_SPECS.includes(specName.toLowerCase()))
    .map(
      ({ specName, specValue } = {}) => ({
        specValue,
        specName: SPECS_TO_DISPLAY[specName.toLowerCase()]
      })
    )
